import React from 'react';
import { Check, Gift, Clock, ShieldCheck, Truck, Lock } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
import { useCountdown } from '../hooks/useCountdown';
export function ValueStack() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const CHECKOUT_URL = 'https://emalia.lat/cart/48340125352186:1';
  return <section id="offer" className="py-12 bg-gradient-to-b from-white to-gray-50" data-id="element-242">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 overflow-hidden relative" data-id="element-244">
          {/* Top Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-accent-coral text-white px-6 py-1 rounded-b-lg font-bold text-sm shadow-md z-10" data-id="element-245">
            OFERTA LIMITADA
          </div>

          <div className="p-6 md:p-10 pt-12" data-id="element-246">
            <h2 className="text-3xl md:text-4xl font-extrabold text-center text-secondary mb-2" data-id="element-247">
              Todo lo que necesitas para tu reset
            </h2>
            <p className="text-center text-gray-500 mb-8" data-id="element-248">
              Acceso inmediato + Bonos de regalo
            </p>

            {/* Main Content Grid */}
            <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-249">
              {/* Left: What you get */}
              <div className="space-y-4" data-id="element-250">
                <h3 className="font-bold text-lg text-secondary border-b border-gray-100 pb-2 mb-4" data-id="element-251">
                  Lo que recibes hoy:
                </h3>

                <div className="flex items-start gap-3" data-id="element-252">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-253">
                    <Check className="h-4 w-4 text-primary" data-id="element-254" />
                  </div>
                  <div data-id="element-255">
                    <span className="font-bold text-gray-800 block" data-id="element-256">
                      Protocolo completo 14 días
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-257">
                      Paso a paso detallado
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-258">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-259">
                    <Check className="h-4 w-4 text-primary" data-id="element-260" />
                  </div>
                  <div data-id="element-261">
                    <span className="font-bold text-gray-800 block" data-id="element-262">
                      Guía de comida real en Colombia
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-263">
                      Marcas y productos locales
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-264">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-265">
                    <Check className="h-4 w-4 text-primary" data-id="element-266" />
                  </div>
                  <div data-id="element-267">
                    <span className="font-bold text-gray-800 block" data-id="element-268">
                      Checklist/Tracker diario
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-269">
                      Solo 2 minutos al día
                    </span>
                  </div>
                </div>
              </div>

              {/* Right: Bonuses */}
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-270">
                <h3 className="font-bold text-lg text-accent-coral flex items-center gap-2 mb-4" data-id="element-271">
                  <Gift className="h-5 w-5" data-id="element-272" />
                  Bonos GRATIS:
                </h3>

                <ul className="space-y-3" data-id="element-273">
                  <li className="flex items-center gap-2 text-sm" data-id="element-274">
                    <span className="w-1.5 h-1.5 bg-accent-coral rounded-full" data-id="element-275"></span>
                    <span className="font-medium text-gray-700" data-id="element-276">
                      BONO #1: Kit Antojos 4:00 PM
                    </span>
                  </li>
                  <li className="flex items-center gap-2 text-sm" data-id="element-277">
                    <span className="w-1.5 h-1.5 bg-accent-coral rounded-full" data-id="element-278"></span>
                    <span className="font-medium text-gray-700" data-id="element-279">
                      BONO #2: Ritual del Tinto
                    </span>
                  </li>
                  <li className="flex items-center gap-2 text-sm" data-id="element-280">
                    <span className="w-1.5 h-1.5 bg-accent-coral rounded-full" data-id="element-281"></span>
                    <span className="font-medium text-gray-700" data-id="element-282">
                      BONO #3: Radar de Azúcar
                    </span>
                  </li>
                </ul>

                <div className="mt-4 pt-4 border-t border-gray-200 text-center" data-id="element-283">
                  <p className="text-xs text-gray-500" data-id="element-284">
                    Valor real de los bonos:
                  </p>
                  <p className="text-gray-400 line-through font-medium" data-id="element-285">
                    $105.000 COP
                  </p>
                </div>
              </div>
            </div>

            {/* Price Section */}
            <div className="bg-secondary/5 rounded-2xl p-6 text-center border border-secondary/10 mb-8" data-id="element-286">
              <div className="flex justify-center items-center gap-2 mb-2" data-id="element-287">
                <span className="text-gray-500 line-through text-lg" data-id="element-288">
                  $230.000
                </span>
                <span className="bg-accent-coral text-white text-xs font-bold px-2 py-1 rounded-md" data-id="element-289">
                  -87% OFF
                </span>
              </div>

              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-290">
                <span className="text-5xl md:text-6xl font-extrabold text-secondary tracking-tight" data-id="element-291">
                  $29.999
                </span>
                <span className="text-xl font-bold text-gray-500" data-id="element-292">COP</span>
              </div>

              <div className="flex items-center justify-center gap-2 text-red-600 font-medium text-sm bg-white inline-flex px-4 py-1 rounded-full shadow-sm border border-red-100" data-id="element-293">
                <Clock className="h-4 w-4" data-id="element-294" />
                <span data-id="element-295">
                  La oferta termina en: {minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </span>
              </div>
            </div>

            {/* CTA */}
            <div className="space-y-6" data-id="element-296">
              <HolographicButton href={CHECKOUT_URL} fullWidth className="text-xl py-5 shadow-2xl shadow-primary/30" data-id="element-297">
                QUIERO COMENZAR YA
              </HolographicButton>

              {/* Visual Trust Badges */}
              <div className="grid grid-cols-3 gap-4 border-t border-gray-100 pt-6" data-id="element-298">
                <div className="flex flex-col items-center text-center gap-2" data-id="element-299">
                  <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center text-green-600" data-id="element-300">
                    <Lock className="h-5 w-5" data-id="element-301" />
                  </div>
                  <div data-id="element-302">
                    <p className="font-bold text-xs text-gray-800" data-id="element-303">
                      Pago 100% Seguro
                    </p>
                    <p className="text-[10px] text-gray-500" data-id="element-304">
                      Encriptación SSL
                    </p>
                  </div>
                </div>

                <div className="flex flex-col items-center text-center gap-2" data-id="element-305">
                  <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-blue-600" data-id="element-306">
                    <Truck className="h-5 w-5" data-id="element-307" />
                  </div>
                  <div data-id="element-308">
                    <p className="font-bold text-xs text-gray-800" data-id="element-309">
                      Entrega Inmediata
                    </p>
                    <p className="text-[10px] text-gray-500" data-id="element-310">
                      Acceso por Email
                    </p>
                  </div>
                </div>

                <div className="flex flex-col items-center text-center gap-2" data-id="element-311">
                  <div className="w-10 h-10 bg-amber-50 rounded-full flex items-center justify-center text-amber-600" data-id="element-312">
                    <ShieldCheck className="h-5 w-5" data-id="element-313" />
                  </div>
                  <div data-id="element-314">
                    <p className="font-bold text-xs text-gray-800" data-id="element-315">
                      Garantía Total
                    </p>
                    <p className="text-[10px] text-gray-500" data-id="element-316">
                      7 Días de prueba
                    </p>
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="flex justify-center gap-4 opacity-60 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-317">
                <img src="https://cdn.magicpatterns.com/uploads/kghmG89Hkaibmwg1RnVYri/Visa_logo.png" alt="Visa" className="h-5 w-auto object-contain" data-id="element-318" />
                <img src="https://cdn.magicpatterns.com/uploads/wtSaJSJvffJxG6juw3kUSJ/Mastercard_logo.png" alt="Mastercard" className="h-5 w-auto object-contain" data-id="element-319" />
                <img src="https://cdn.magicpatterns.com/uploads/6bzYwiAPHy4Q5xVwWnqUK9/Nequi_logo.png" alt="Nequi" className="h-5 w-auto object-contain" data-id="element-320" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}